var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c(_vm.component,_vm._g(_vm._b({tag:"component",attrs:{"aggregation":_vm.aggregation,"role":_vm.role,"id-filter":_vm.idFilter}},'component',_vm.props,false),_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }